import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';
import { IUserInfo } from 'src/app/admin/models/user.interface';
import { NotificationsService } from 'src/app/services/notifications.service';
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  @Input() showMenu: boolean = false;
  openMenu = false;
  @Input() userInfo!: IUserInfo;
  @ViewChild('popoverProfile') popover;
  urlCurrent: string = this.location.path();

  menu = [
    { label: 'Home', icon: 'assets/img/home.svg', route: '/home' },
    {
      label: 'Visualización de datos',
      icon: 'assets/img/petroleum.svg',
      route: '/field-list',
      is_admin: false
    },
    // {
    //   label: 'Datos disponibles',
    //   icon: 'assets/img/data-source.svg',
    //   route: '/upload-model-data',
    //   is_admin: true
    // },
    {
      label: 'Roles de usuarios',
      icon: 'assets/img/user-circle.svg',
      route: '/user-roles',
      is_admin: true
    },
    {
      label: 'Recomendaciones, alertas y notificaciones',
      icon: 'assets/img/alerts.svg',
      route: '/advisories',
      is_admin: false
    },
    {
      label: 'Historial de cargas',
      icon: 'assets/img/history.svg',
      route: '/upload-model-data',
      is_admin: false
    },
  ];
  isOpen = false;
  backgroundColorProfile = '';
  countAlerts: number = 0;
  currentUserInfo!: IUserInfo;
  constructor(
    private location: Location, 
    private authService: AuthService, 
    private router: Router, 
    private _notificationsService: NotificationsService) {
      this.currentUserInfo = this.authService.getAppUser()
    }

  ngOnInit() {
    this._notificationsService.getAlertsCounts().subscribe((alert) => this.countAlerts = alert.count)
  }

  goHome(){
    this.router.navigate(['/home'])
  }

  logout() {
    this.authService.logout();
  }

  presentPopover(e: Event) {
    this.popover.event = e;
    this.isOpen = true;
  }

  showOption(option: any): boolean {
    return option.is_admin ? this.currentUserInfo?.is_admin : true;
  }

  getInitials(name) {
    let palabras = name.split(' ');
    palabras =
      palabras.length >= 4
        ? [palabras[0], palabras[2]]
        : palabras.length == 3
        ? [palabras[0], palabras[1]]
        : palabras;
    return palabras
      .map((palabra) => palabra[0])
      .join('')
      .toUpperCase();
  }
  startMenu() {
    this.openMenu = !this.openMenu;
    this.resize();
  }

  resize() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }

  get hasLicense(): boolean {
    return this.userInfo && this.userInfo.has_license ? true : false;
  }
}
